// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FFU8","type":"styles_type__25TZr","choices":"styles_choices__2RsKc"};